import { useParams, Navigate } from "react-router-dom";
import SubcategoryPageLayout from "@/components/SubcategoryPageLayout";
import infissiSubs from "@/data/infissiSubcategories";

const InfissiSubcategoryPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const sub = slug ? infissiSubs[slug] : null;

  if (!sub) return <Navigate to="/infissi" replace />;

  return (
    <SubcategoryPageLayout
      heading={sub.heading}
      subtitle={sub.subtitle}
      categoryKey={sub.categoryKey}
      backTo="/infissi"
      backLabel="Infissi & Serramenti"
    />
  );
};

export default InfissiSubcategoryPage;
